import { updateObject } from 'store/utility';
import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
    tags: {},
    loading: false,
    init: false,
    relations: {},
    treeLoading: false,
    treeList: {},
    tree: {}
}

const createTreeList = (tags) => {
    for(let id in tags) {
        let lvl = tags[id].cat;
        //let childs = stock[id].refids.map;
        tags[id] = { id: id, name: tags[id].desc, desc: tags[id].word, usecount: tags[id].usecount, childIds: tags[id].relids, parentIds: [] };
        if(lvl) {
            tags[id].level = lvl;
        }
    }

    return tags;
}

const getAllChildIds = (tags) => {
    let childIds = [];
    Object.values(tags).forEach(tag => {
        childIds = [ ...childIds, ...tag.childIds ];
    });
    return childIds;
}

const getChilds = (tags, ids, parents) => {
    const res = [];
    ids.forEach(id => {
        if(tags[id]) {
            // set all parent ids (child -> parent -> parent -> ...)
            const parentIds = [ ...tags[id].parentIds, ...parents];
            tags[id].parentIds = parentIds;
            res.push(tags[id]);
        } else {
            console.log("ID not exists: " + id);
        }
    });
    return res;
    //return ids.map(id => tags[id]);
}

const createTree = (tags) => {
    const tree = [];
    const allChilds = getAllChildIds(tags);
    
    for(let id in tags) {
        if(!allChilds.includes(id)) {
            tree.push(tags[id]);
        }
        // set all parent ids to child
        const parentIds = [ ...tags[id].parentIds, id ];
        tags[id].children = [ ...getChilds(tags, tags[id].childIds, parentIds) ];
        //delete tags[id].childIds;
    }
    
    return tree;
}

const TagReducer = (state = INITIAL_STATE, action) => {
    let tags;
    switch (action.type) {
        case actionTypes.TAG_CATALOG_SEARCH_START:
            return updateObject(state, { loading: true });
        case actionTypes.TAG_CATALOG_SEARCH_SUCCESS:
            return updateObject(state, { tags: action.tags, loading: false });
        case actionTypes.TAG_CATALOG_SEARCH_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.TAG_CATALOG_NEW_START:
            return updateObject(state, { loading: true });
        case actionTypes.TAG_CATALOG_NEW_SUCCESS:
            tags  = { ...state.tags, [action.id]: { ...action.tag, id: action.id, usecount: 0 } };
            return updateObject(state, { tags: tags, loading: false });
        case actionTypes.TAG_CATALOG_EDIT_START:
            return updateObject(state, { loading: true });
        case actionTypes.TAG_CATALOG_EDIT_SUCCESS:
            tags = { ...state.tags, [action.id]: action.tag };
            return updateObject(state, { tags: tags, loading: false });
        case actionTypes.TAG_CATALOG_DELETE_START:
            return updateObject(state, { loading: true });
        case actionTypes.TAG_CATALOG_DELETE_SUCCESS:
            tags = { ...state.tags };
            delete tags[action.id];
            return updateObject(state, { tags: tags, loading: false });
        case actionTypes.TAG_CATALOG_TAGS_REL_START:
            return updateObject(state, { loading: true });
        case actionTypes.TAG_CATALOG_TAGS_REL_SUCCESS:
            const relations = { ...state.relations };
            relations[action.id] = action.rels;
            return updateObject(state, { relations: relations, loading: false });
        case actionTypes.TAG_TREE_SEARCH_START:
            return updateObject(state, { treeLoading: true });
        case actionTypes.TAG_TREE_SEARCH_SUCCESS:
            tags = createTreeList(action.tags);
            const tree = createTree(tags);
            return updateObject(state, { treeList: tags, tree: tree, treeLoading: false });
        case actionTypes.TAG_TREE_SEARCH_FAIL:
            return updateObject(state, { treeLoading: false });
        default:
            return state;
    }
}

export default TagReducer;
